import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import Loadfirst from './Loadfirst';
import { AuthProvider } from './AuthContext';
import 'bootstrap/dist/css/bootstrap.min.css';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <AuthProvider>
      <Loadfirst />
    </AuthProvider>
  </React.StrictMode>
);
